import React, {useCallback, useMemo} from 'react'
import styled from 'styled-components'
import {useWindowMode} from 'windows'
import {WINDOW_MODE_TABLET_WIDTH} from 'consts/common'
import {TemplateDropboxProfile} from '../profile'
import {TemplateDropboxMainProps} from './TemplateDropboxMainProps'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  padding: 40px;
  gap: 40px;

  @media (max-width: ${WINDOW_MODE_TABLET_WIDTH}px) {
    flex-direction: column;
    gap: 20px;
  }
`

const StyledSectionInfo = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 375px;
  height: 100%;

  @media (max-width: ${WINDOW_MODE_TABLET_WIDTH}px) {
    width: 100%;
    height: initial;
  }
`

const StyledSectionInfoContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 40px;

  @media (max-width: ${WINDOW_MODE_TABLET_WIDTH}px) {
    gap: 20px;
  }
`

const StyledRightSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  @media (max-width: ${WINDOW_MODE_TABLET_WIDTH}px) {
    min-height: 300px;
  }
`

const StyledSectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`

export default function TemplateDropboxMain({
  renderHeader,
  renderInfo,
  renderContent,
}: TemplateDropboxMainProps) {
  const mode = useWindowMode()

  const profileMode = useMemo(() => (mode === 'website' ? 'bar' : 'icon'), [
    mode,
  ])

  const handleRenderProfile = useCallback(
    () => <TemplateDropboxProfile mode={profileMode} />,
    [profileMode],
  )

  const handleRenderHeader = useCallback(
    () => (
      <StyledSectionHeader>
        {renderHeader()}
        {profileMode === 'icon' && handleRenderProfile()}
      </StyledSectionHeader>
    ),
    [profileMode, renderHeader, handleRenderProfile],
  )

  const handleRenderSectionInfo = useMemo(
    () => (
      <StyledSectionInfo>
        <StyledSectionInfoContent>
          {handleRenderHeader()}
          {renderInfo()}
        </StyledSectionInfoContent>
        {profileMode === 'bar' && handleRenderProfile()}
      </StyledSectionInfo>
    ),
    [profileMode, renderInfo, handleRenderHeader, handleRenderProfile],
  )

  const handleRenderSectionContent = useMemo(
    () => <StyledRightSection>{renderContent()}</StyledRightSection>,
    [renderContent],
  )

  return (
    <StyledContainer>
      {handleRenderSectionInfo}
      {handleRenderSectionContent}
    </StyledContainer>
  )
}
